module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bar center"
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    staticClass: "back-img",
    attrs: {
      "src": require("../assets/Back_50.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("content")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ec6c0880!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
// module id = 200
// module chunks = 2